import React, { useRef, useEffect, useCallback } from "react"

import { ParticlesWrapper } from "./styles"

const ParticlesBg = React.memo(() => {
  const divRef = useRef()

  const renderBalls = useCallback(() => {
    // Some random colors
    const colors = [
      "rgba(252,115,3, 0.4)",
      "rgba(252,115,3, 0.7)",
      "rgba(252,115,3, 0.8)",
      "rgba(252,115,3, 0.2)",
      "rgba(252,115,3, 0.9)",
    ]
    const numBalls = 90
    const balls = []
    for (let i = 0; i < numBalls; i++) {
      let ball = document.createElement("div")
      ball.classList.add("ball")
      ball.style.background = colors[Math.floor(Math.random() * colors.length)]
      ball.style.left = `${Math.floor(Math.random() * 100)}vw`
      ball.style.top = `${Math.floor(Math.random() * 100)}vh`
      ball.style.transform = `scale(${Math.random()})`
      ball.style.width = `${Math.random()}em`
      ball.style.height = ball.style.width

      balls.push(ball)
      divRef.current.appendChild(ball)
    }
    // Keyframes
    balls.forEach((el, i, ra) => {
      let to = {
        x: Math.random() * (i % 2 === 0 ? -11 : 11),
        y: Math.random() * 12,
      }

      el.animate(
        [
          { transform: "translate(0, 0)" },
          { transform: `translate(${to.x}rem, ${to.y}rem)` },
        ],
        {
          duration: (Math.random() + 1) * 2000, // random duration
          direction: "alternate",
          fill: "both",
          iterations: Infinity,
          easing: "ease-in-out",
        }
      )
    })
  }, [])

  useEffect(() => {
    renderBalls()
  }, [renderBalls])

  return <ParticlesWrapper className="particles" ref={divRef} />
})

export default ParticlesBg
